let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bwQik")).then(() => parcelRequire('guSrZ'));